/* RIOTBALL LEAGUE strip for the homepage — the red banner, a live leader ticker,
   and the top of the table, one tap from the arena. Reads /api/riotball/records. */
import { ChevronRight, Crown, Dices, Swords } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { API, TEAM_ORDER, TEAMS } from "./riotball/constants";

export function RiotballLeagueStrip() {
  const [records, setRecords] = useState(null);
  const [pot, setPot] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () =>
      fetch(`${API}/riotball/records`)
        .then((r) => (r.ok ? r.json() : null))
        .then((data) => {
          if (alive && data) setRecords(data);
        })
        .catch(() => {});
    const loadPot = () =>
      fetch(`${API}/dolosway/board`)
        .then((r) => (r.ok ? r.json() : null))
        .then((data) => {
          if (alive && data) setPot(data);
        })
        .catch(() => {});
    load();
    loadPot();
    const interval = window.setInterval(() => {
      load();
      loadPot();
    }, 60000);
    return () => {
      alive = false;
      window.clearInterval(interval);
    };
  }, []);

  const table = TEAM_ORDER.map((key) => ({ key, ...TEAMS[key], best: records ? records[key] || 0 : 0 }))
    .sort((a, b) => b.best - a.best);
  const racing = table.filter((t) => t.best > 0);
  const leader = racing[0] || null;

  return (
    <section className="riotball-league-strip" data-testid="riotball-league-strip">
      <Reveal>
        <Link to="/riotball" className="league-strip-banner rb-glitch" data-testid="league-strip-banner">
          <img src="/assets/riotball-banner.png" alt="AL RIOTBALL — Alliance League banner" />
          <img className="rb-glitch-copy rb-glitch-a" src="/assets/riotball-banner.png" alt="" aria-hidden="true" />
          <img className="rb-glitch-copy rb-glitch-b" src="/assets/riotball-banner.png" alt="" aria-hidden="true" />
        </Link>
        <div className="arena-ticker league-strip-ticker" data-testid="league-strip-ticker">
          <span className="arena-ticker-label">LEAGUE RACE //</span>
          <div className="arena-ticker-viewport">
            <div className="arena-ticker-track">
              {(racing.length ? [...racing, ...racing] : [null, null]).map((t, i) =>
                t ? (
                  <span
                    key={i}
                    className={`arena-ticker-item${i === 0 || i === racing.length ? " arena-ticker-live" : ""}`}
                    style={{ color: TEAMS[t.key].color }}
                    data-testid={i === 0 ? "strip-ticker-leader" : undefined}
                  >
                    {i === 0 || i === racing.length ? <em className="ticker-live-dot" /> : null}
                    {i === 0 || i === racing.length ? "LIVE — " : ""}
                    {["1ST", "2ND", "3RD"][racing.indexOf(t)] || `${racing.indexOf(t) + 1}TH`} {t.name} {t.best}
                  </span>
                ) : (
                  <span key={i} className="arena-ticker-item">NO SCORES ON THE BOARD YET — THE FIRST RUN SETS THE LEAGUE</span>
                )
              )}
              {[0, 1].map((half) => (
                <span key={`pot-${half}`} className="arena-ticker-item strip-ticker-pot" data-testid={half === 0 ? "strip-ticker-pot" : undefined}>
                  <Dices size={11} /> TABLE POT — {pot ? `${pot.pot} PTS ACROSS ${pot.games} ${pot.games === 1 ? "TABLE" : "TABLES"}` : "30 PTS · THE FIRST TABLE FEEDS IT"} · BOARD BOSS TAKES IT SUNDAY
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="league-strip-body">
          <div className="league-strip-top">
            {table.slice(0, 3).map((t, i) => (
              <Link
                to={`/riotball/team/${{ red: "red-force", white: "white-guards", vultures: "voltaic-vultures" }[t.key] || t.key}`}
                className={`league-strip-row${i === 0 && t.best > 0 ? " is-leader" : ""}`}
                style={{ "--team-color": t.color }}
                key={t.key}
                data-testid={`league-strip-row-${t.key}`}
              >
                <span className="league-strip-rank">{i === 0 && t.best > 0 ? <Crown size={12} /> : null}{i + 1}</span>
                <img src={t.emblem} alt={`${t.name} crest`} loading="lazy" />
                <strong>{t.name}</strong>
                <em>{t.best} {t.best === 1 ? "GOAL" : "GOALS"}</em>
              </Link>
            ))}
          </div>
          <Link to="/riotball" className="button button-primary league-strip-cta" data-testid="league-strip-cta">
            <Swords size={15} /> ENTER THE ARENA <ChevronRight size={14} />
          </Link>
        </div>
      </Reveal>
    </section>
  );
}
